export const server = 'https://heinrichlimited.com/administration/'
export const server_api = 'https://heinrichlimited.com/administration/api/v1/'
export const imgUrl = 'public/uploads/what_we_do/medium/'
export const largeImgUrl = 'public/uploads/what_we_do/large/'
export const productImgUrl = 'public/uploads/products/large/'
export const blogimageUrl = 'public/uploads/blog/large/'
export const clientimg = 'public/uploads/gallery/small/'
export const url = "https://heinrichlimited.com/"
export const url2 = "https://heinrichlimited.com"

